export default class SvgComponent {
  static template({classList, icon} = {}) {
    let attrs = [classList && `class="${classList.join(' ')}"`].filter((x) => x).join(' ');

    if (attrs) {
      attrs = ` ${attrs}`;
    }

    return `<svg${attrs}><use xlink:href="/static/core/img/sprites.svg#${icon}"></use></svg>`;
  }
}
